import React from 'react'
import styled from 'styled-components'
import { useHistory } from 'react-router-dom'

const BurgerMenu = ({ options }) => {
  const history = useHistory()
  const handleClick = () => {
    const toggler = document.querySelector(`.menu__toggler`)
    const menu = document.querySelector(`.menu`)
    if(!menu.classList.contains(`active`)) menu.style.display = `flex`
    setTimeout(() => {
      toggler.classList.toggle(`active`)
      menu.classList.toggle(`active`)
      if(!menu.classList.contains(`active`)) setTimeout(() => menu.style.display = `none`,500)
    },0)
  }
  return (
    <Container>
      <Options className="menu">
        {options.map((option,index) => {
          const { route,label,Icon } = option
          const { pathname } = history.location
          return (
            <Option 
              active={pathname === route || (route !== `/` && pathname.includes(route))}
              onClick={() => {
                document.querySelector(`.menu__toggler`).classList.remove(`active`)
                document.querySelector(`.menu`).classList.remove (`active`)
                history.push(route)
              }}
              key={index}>
              {Icon && <Icon size={16}/>}
              <Heading>{label}</Heading>
            </Option>
          )
        })}
      </Options>
      <MenuToggler 
        onClick={handleClick}
        className="menu__toggler"><span></span></MenuToggler>
    </Container>
  )
}

export default BurgerMenu 

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex:0;
  align-items: center;
  overflow-x:hidden;
  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`

const Options = styled.div`
  position: absolute;
  top:0;
  height:100vh;
  right: calc(-1 * max(40vw,350px));
  z-index: 998;
  color: white;
  background-color:rgba(0,0,0,0.9);
  clip-path: polygon(0 0, 100% 0, 100% 100%, 25% 100%);
  width: max(40vw,350px);
  height: 100%;
  padding: calc(max(40vw,350px) * 0.25);
  padding-top:10vh;
  padding-right:2vh;
  flex-direction: column;
  justify-content: flex-start;
  transition: 300ms right cubic-bezier(0.77, 0, 0.175, 1);
  display:none;
  &.active {
    right: 0;
  }
  p {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
`
const MenuToggler = styled.div`
  position: absolute;
  top: 25px;
  right: 40px;
  z-index: 999;
  height: 28px;
  width: 28px;
  outline: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  
  span,
  span::before,
  span::after {
    position: absolute;
    content: '';
    width: 28px;
    height: 2.5px;
    background: black;
    border-radius: 20px;
    transition: 500ms cubic-bezier(0.77, 0, 0.175, 1);
  }
  
  span::before {
    top: -8px;
  }
  
  span::after {
    top: 8px;
  }
  
  &.active > span  {
    background: transparent;
  }

  &.active > span::before,
  &.active > span::after {
    background: white;
    top: 0px;
  }

  &.active > span::before  {
    transform: rotate(-225deg);
  }

  &.active > span::after  {
    transform: rotate(225deg);
  }

  *,
  *::before,
  *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;

  }
`
const Option = styled.div`
  gap:20px;
  justify-content:flex-start;
  cursor:pointer;
  padding:15px 15px;
  box-sizing:border-box;
  border-radius:40px;
  border-radius:0;
  flex:0;
  border-bottom:${p => p.active ? `1px solid black` : ``};
`
const Heading = styled.div`
  font-weight:bold;
  box-sizing:border-box;
  font-size:1.3rem;
  margin:0;
  padding:0;
  flex:0;
  white-space: nowrap;
`

